<template>
  <div v-if="show" class="modal-full z-25">
    <div class="modal-bg bc-black" @click.prevent="closeModal"></div>
    <div class="p-a pos-center bc-brand p d-f ai-c fd-c w-100 h-100">
      <p class="m-0 tt-up">Create profile to continue</p>
      <SignUpTabs :for-submit-demo-modal="true" />
      <div class="p-a t-0 r-0 p pointer" @click.prevent="closeModal">
      <IconBase w="15" h="15" viewBox="0 0 15 15" icon-name="close">
        <IconBack />
      </IconBase>
    </div>
    </div>

  </div>
</template>

<script>
import SignUpTabs from "@/components/settings/SignUpTabs.vue";
import IconBack from "@/assets/icons/IconBack.vue";
import IconBase from "@/assets/icons/IconBase.vue";

export default {
  name: "AuthModal",
  components: { IconBase, IconBack, SignUpTabs },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$root.$emit("on-close");
    },
  },
};
</script>

<style scoped lang="scss"></style>
